<template lang="">
  <v-card>
    <s-crud
      :config="config"
      title="Contrato de Productores"
      :filter="filter"
      search-input
      add
      add-no-function
      @add="add()"
      edit
      @edit="edit()"
      remove
      ref="scrudProducerContract"
      @rowSelected="rowSelected($event)"
    >
      <template v-slot:filter>
        <v-container>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" md="3">
              <s-select-producer
                label="Productor"
                v-model="filter.PrdID"
              ></s-select-producer>
            </v-col>

            <v-col cols="12" md="3">
              <s-select
                label="Estado"
                v-model="filter.StatusContract"
                :items="[
                  { text: 'Vigente', value: 1 },
                  { text: 'Vencido', value: 2 },
                  { text: 'Por vencer', value: 3 },
                ]"
                item-value="value"
                item-text="text"
                clearable
              ></s-select>
            </v-col>

            <v-col cols="12" md="3">
              <s-date
                label="Fecha de Inicio"
                v-model="filter.BeginDateContract"
                clearable
              ></s-date>
            </v-col>

            <v-col cols="12" md="3">
              <s-date
                label="Fecha de Fin"
                v-model="filter.EndDateContract"
                clearable
              ></s-date>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:PctTermsOfPayment="{ row }">
        <span
          style="white-space: pre-wrap; word-break: break-word"
          v-text="row.PctTermsOfPayment"
        ></span>
      </template>

      <!-- Formatear fechas -->
      <template v-slot:BeginDateContract="{ row }">
        {{ formatDate(row.BeginDateContract) }}
      </template>

      <template v-slot:EndDateContract="{ row }">
        {{ formatDate(row.EndDateContract) }}
      </template>

      <!-- Estado con color -->
      <template v-slot:StatusContractName="{ row }">
        <v-chip
          x-small
          class="font-weight-bold"
          :color="getStatusColor(row.StatusContract)"
          dark
        >
          {{ row.StatusContractName || "N/A" }}
        </v-chip>
      </template>
    </s-crud>

    <!-- TABLA DE DETALLES INFERIOR -->
    <v-card
      class="mt-6"
      v-if="selectedContractDetails && selectedContractDetails.length > 0"
    >
      <v-toolbar flat dense color="#8e8f91" dark>
        <v-toolbar-title style="font-size: 14px">
          <v-icon size="16" class="mr-2">mdi-format-list-bulleted</v-icon>
          Detalle del Contrato (Fundos Registrados)
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="selectedDetailsForContract.length > 0"
          small
          color="success"
          @click="showContractDialog = true"
          class="font-weight-bold"
        >
          <v-icon left small>mdi-file-document-edit-outline</v-icon>
          Generar Contrato
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headersFarmLotsReadOnly"
        :items="selectedContractDetails"
        v-model="selectedDetailsForContract"
        show-select
        item-key="FltID"
        class="elevation-1"
        dense
        hide-default-footer
        @click:row="onLotRowClicked"
        :item-class="rowClass"
        style="cursor: pointer"
      ></v-data-table>
    </v-card>

    <!-- ADENDAS DEL FUNDO SELECCIONADO (TABLA INFERIOR) -->
    <v-card
      class="mt-6"
      v-if="selectedLotForAdenda"
      :loading="loadingAdendas"
      elevation="2"
    >
      <v-toolbar flat dense color="#8e8f91" dark>
        <v-toolbar-title style="font-size: 14px">
          <v-icon size="16" class="mr-2">mdi-file-clock-outline</v-icon>
          Historial de Adendas - Fundo:
          <strong>{{ selectedLotForAdenda.FagName }}</strong> (Lote:
          <strong>{{ selectedLotForAdenda.FltName }}</strong
          >)
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          x-small
          @click="
            selectedLotForAdenda = null;
            adendaList = [];
          "
        >
          <v-icon x-small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-data-table
          :headers="headersAdendasList"
          :items="adendaList"
          class="elevation-0"
          dense
          hide-default-footer
          no-data-text="Este fundo/lote no registra ninguna adenda activa."
        >
          <!-- Formatear fechas -->
          <template v-slot:item.BeginDate="{ item }">
            {{ formatDate(item.BeginDate) }}
          </template>
          <template v-slot:item.EndDate="{ item }">
            {{ formatDate(item.EndDate) }}
          </template>

          <!-- Hectáreas, Plantas, Volumen -->
          <template v-slot:item.FltHectares="{ item }">
            {{ item.FltHectares ? item.FltHectares.toFixed(2) : "0.00" }} ha
          </template>
          <template v-slot:item.FltPlants="{ item }">
            {{ item.FltPlants || 0 }}
          </template>
          <template v-slot:item.FltVolume="{ item }">
            {{ item.FltVolume ? item.FltVolume.toFixed(2) : "0.00" }} t
          </template>

          <!-- Columna de Acción PDF -->
          <template v-slot:item.actionPdf="{ item }">
            <v-btn
              icon
              small
              color="red darken-3"
              @click.stop="onDownloadAdendaPDF(item)"
              title="Descargar PDF de la Adenda"
            >
              <v-icon small>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- DIALOGO DE CONTRATO (Nuevo componente) -->
    <v-dialog v-model="showContractDialog" fullscreen persistent>
      <pdf-contract-producer
        v-if="showContractDialog"
        :contrato="currentSelectedContract"
        :lotes="selectedDetailsForContract"
        @close="showContractDialog = false"
      />
    </v-dialog>

    <!-- MODAL PARA AGREGAR Y EDITAR CONTRATOS -->
    <v-dialog
      v-model="dialog"
      max-width="1000px"
      persistent
      scrollable
      v-if="dialog"
    >
      <v-card class="rounded-lg">
        <v-toolbar color="#2c3e50" dark flat dense>
          <v-toolbar-title class="font-weight-bold ml-2">
            <v-icon left>mdi-file-document-edit</v-icon>
            {{
              editMode
                ? "Editar Contrato de Productor"
                : "Nuevo Contrato de Productor"
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4" style="background-color: #f8f9fa">
          <v-container>
            <v-row dense>
              <v-col cols="12" md="7">
                <s-select-producer
                  v-model="editedItem.PrdID"
                  label="Productor"
                  :text="editedItem.PrdCardName"
                  :disabled="editMode"
                  @changeProd="onProducerChange($event, editedItem)"
                ></s-select-producer>
              </v-col>
              <v-col cols="12" md="5">
                <s-select-campaign-area
                  label="Campaña"
                  v-model="editedItem.CmaId"
                  typeArea="1"
                  clearable
                  @input="updateAllWeeklyProjections()"
                ></s-select-campaign-area>
              </v-col>
            </v-row>

            <v-row dense class="mt-2">
              <v-col cols="12" md="6">
                <s-select-definition
                  v-model="editedItem.TypeProducerContract"
                  :def="1629"
                  clearable
                  label="Tipo de Contrato"
                >
                </s-select-definition>
              </v-col>
              <v-col cols="12" md="3">
                <s-date
                  label="Fecha Inicio"
                  v-model="editedItem.BeginDateContract"
                  clearable
                ></s-date>
              </v-col>
              <v-col cols="12" md="3">
                <s-date
                  label="Fecha Fin"
                  v-model="editedItem.EndDateContract"
                  clearable
                ></s-date>
              </v-col>
            </v-row>

            <v-row dense class="mt-2">
              <v-col cols="12" md="6">
                <s-text
                  label="Precio por Kg"
                  decimal
                  v-model="editedItem.PctPrice"
                  suffix="S/."
                  :maxDecimal="3"
                  :min="0"
                ></s-text>
              </v-col>
              <v-col cols="12" md="6">
                <s-text
                  label="Volumen Estimado"
                  decimal
                  v-model="editedItem.PctVolume"
                  suffix="t"
                  :maxDecimal="3"
                  :min="0"
                ></s-text>
              </v-col>
            </v-row>

            <v-row dense class="mt-2">
              <v-col cols="12">
                <s-textarea
                  label="Condiciones de Pago"
                  v-model="editedItem.PctTermsOfPayment"
                  :rows="3"
                ></s-textarea>
              </v-col>
            </v-row>

            <v-row class="mt-4" v-if="farmLotsList && farmLotsList.length > 0">
              <!-- TABLA DE FUNDOS (FARMLOTS) -->
              <v-col cols="12">
                <v-card outlined>
                  <v-toolbar flat dense color="grey lighten-4">
                    <v-toolbar-title
                      style="font-size: 14px; font-weight: bold; color: #2c3e50"
                    >
                      <v-icon size="18" class="mr-2" color="success"
                        >mdi-sprout</v-icon
                      >
                      Seleccionar Fundos del Productor
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-data-table
                    :headers="headersFarmLots"
                    :items="farmLotsList"
                    v-model="editedItem.TasProducerContractDetail"
                    show-select
                    item-key="FltID"
                    class="elevation-0"
                    dense
                    hide-default-footer
                    :item-is-selectable="isSelectable"
                    @item-selected="onItemSelected"
                    @toggle-select-all="onToggleSelectAll"
                  >
                    <!-- SLOT PARA BLOQUEAR EL CHECKBOX DE FILAS CON ADENDAS -->
                    <template
                      v-slot:item.data-table-select="{
                        item,
                        isSelected,
                        select,
                      }"
                    >
                      <v-simple-checkbox
                        :value="isSelected"
                        :disabled="
                          !!(item.CountAddenda && item.CountAddenda > 0)
                        "
                        @input="select($event)"
                      ></v-simple-checkbox>
                    </template>

                    <!-- SLOT PARA EL BOTÓN DE ADENDAS -->
                    <template v-slot:item.addendaAction="{ item }">
                      <v-btn
                        v-if="item.PcdID && item.PcdID > 0"
                        icon
                        small
                        color="light-blue darken-4"
                        @click="openAddendaModal(item)"
                        title="Gestionar Adendas"
                      >
                        <v-icon size="20"
                          >mdi-file-document-multiple-outline</v-icon
                        >
                      </v-btn>
                      <span v-else class="text-caption text--disabled"
                        >---</span
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            class="px-4 font-weight-bold"
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            depressed
            class="px-6 font-weight-bold"
            @click="saveForm"
          >
            <v-icon left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG PARA ADENDAS DE UN FUNDO -->
    <v-dialog
      v-model="dialogAddenda"
      v-if="dialogAddenda"
      width="800"
      persistent
    >
      <s-producer-contract-detail-addenda
        :PcdID="selectedPcdID"
        :FltID="selectedFltID"
        :contractBeginDate="editedItem.BeginDateContract"
        :contractEndDate="editedItem.EndDateContract"
        @close="dialogAddenda = false"
        @adendaChanged="refreshContractDetails"
      />
    </v-dialog>

    <!-- DIALOGO DE ADENDA PDF (Nuevo componente) -->
    <v-dialog
      v-model="showAdendaPdfDialog"
      fullscreen
      persistent
      v-if="showAdendaPdfDialog"
    >
      <pdf-addenda-producer
        :contrato="currentSelectedContract"
        :adenda="selectedAdendaForPdf"
        @close="
          showAdendaPdfDialog = false;
          selectedAdendaForPdf = null;
        "
      />
    </v-dialog>
  </v-card>
</template>

<script>
import TasProducerContractService from "../../../services/Technicalassistance/TasProducerContractService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import sSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import sSelectProducerFarmLot from "@/components/TecnicalAssistence/ProducersFarms/sSelectProducerFarmLot";
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";
import _WeeklyProjectionService from "../../../services/Technicalassistance/WeeklyProjectionService";
import PdfContractProducer from "./PdfContractProducer.vue";
import PdfAddendaProducer from "./PdfAddendaProducer.vue";
import sProducerContractDetailAddenda from "@/components/TecnicalAssistence/ProducersFarms/sProducerContractDetailAddenda.vue";

export default {
  components: {
    sToolbarPerson,
    sSelectProducer,
    sSelectProducerFarmLot,
    SSelectCampaignArea,
    PdfContractProducer,
    PdfAddendaProducer,
    sProducerContractDetailAddenda,
  },
  data() {
    return {
      filter: {
        PctProducer: null,
        BeginDateContract: null,
        EndDateContract: null,
        StatusContract: null,
        PctID: null,
      },
      dialog: false,
      editMode: false,
      editedItem: {},
      showContractDialog: false,
      selectedDetailsForContract: [],
      currentSelectedContract: {},
      dialogAddenda: false,
      selectedPcdID: 0,
      selectedFltID: 0,
      config: {
        service: TasProducerContractService,
        model: {
          PctID: "ID",
        },
        headers: [
          { text: "ID", value: "PctID" },
          { text: "Campaña", value: "CmaName" },
          { text: "Fecha Inicio", value: "BeginDateContract" },
          { text: "Fecha Fin", value: "EndDateContract" },
          {
            text: "Estado",
            value: "StatusContractName",
            align: "center",
            width: 100,
          },
          { text: "Tipo de Contrato", value: "TypeProducerContractName" },
          { text: "Nombre", value: "PrdCardName" },
          { text: "Precio por Kg", value: "PctPrice" },
          { text: "Volumen Estimado (t)", value: "PctVolume" },
          { text: "Condiciones de Pago", value: "PctTermsOfPayment" },
        ],
      },
      ObjProducer: [],
      farmLotsList: [],
      selectedContractDetails: [],
      loadingLots: false,
      selectedLotForAdenda: null,
      adendaList: [],
      loadingAdendas: false,
      showAdendaPdfDialog: false,
      selectedAdendaForPdf: null,
      headersAdendasList: [
        {
          text: "Fecha Inicio",
          value: "BeginDate",
          width: 120,
          align: "center",
        },
        { text: "Fecha Fin", value: "EndDate", width: 120, align: "center" },
        { text: "Fundo", value: "FagName", width: 130 },
        { text: "Lote", value: "FltName", width: 100 },
        {
          text: "Responsable Cobrador",
          value: "ResponsibleFarmLot",
          width: 180,
        },

        {
          text: "PDF",
          value: "actionPdf",
          sortable: false,
          align: "center",
          width: 80,
        },
      ],
      headersFarmLots: [
        {
          text: "Adenda",
          value: "addendaAction",
          sortable: false,
          align: "center",
          width: 90,
        },
        { text: "ID", value: "FltID", width: 150 },
        { text: "Fundo", value: "FagName", width: 150 },
        { text: "Lote", value: "FltName", width: 100 },
        {
          text: "Responsable Cobrador",
          value: "ResponsibleFarmLot",
          width: 180,
        },
        { text: "Certificación", value: "CertificationName", width: 180 },
        { text: "Dirección", value: "FagAddress", width: 180 },
        { text: "Zona", value: "ZonIDText", width: 100 },
        { text: "Sub Zona", value: "SzoIDText", width: 120 },
        { text: "Cultivo", value: "TypeCultiveText", width: 120 },
        { text: "Variedad", value: "VrtIDText", width: 120 },
        { text: "Hectáreas", value: "FltHectares", align: "right", width: 90 },
        { text: "Plantas", value: "FltPlants", align: "right", width: 90 },
        {
          text: "Volumen (Tn)",
          value: "FltVolume",
          align: "right",
          width: 100,
        },
        {
          text: "Potencial Jabas",
          value: "FltJabasPotential",
          align: "right",
          width: 110,
        },
        {
          text: "Est. Fenológico",
          value: "typeStatePhenologicalName",
          width: 140,
        },
        {
          text: "% Fenológico",
          value: "StpPercentage",
          align: "right",
          width: 100,
        },
        {
          text: "Inicio Cosecha (Sem)",
          value: "DateBeginharvest",
          align: "right",
          width: 150,
        },
        {
          text: "Fin Cosecha (Sem)",
          value: "DateEndharvest",
          align: "right",
          width: 140,
        },
        {
          text: "Proyección Jabas",
          value: "WptProjectedJabas",
          align: "right",
          width: 120,
        },
      ],
    };
  },
  created() {
    if (this.$route.query.PctID) {
      this.filter.PctID = parseInt(this.$route.query.PctID);

      // Limpiar el parámetro de la URL para evitar re-filtrados al refrescar
      const query = { ...this.$route.query };
      delete query.PctID;
      this.$router.replace({ query });
    }
  },
  computed: {
    headersFarmLotsReadOnly() {
      return this.headersFarmLots.filter((h) => h.value !== "addendaAction");
    },
  },
  watch: {
    "filter.PrdID"(newVal) {
      if (newVal) this.filter.PctID = null;
    },
    "filter.StatusContract"(newVal) {
      if (newVal) this.filter.PctID = null;
    },
    "filter.BeginDateContract"(newVal) {
      if (newVal) this.filter.PctID = null;
    },
    "filter.EndDateContract"(newVal) {
      if (newVal) this.filter.PctID = null;
    },
  },
  methods: {
    async onProducerChange(data, item) {
      if (this.editMode) return; // En modo edición, el detalle ya viene cargado con sus PcdID desde ProducerContractDetailList

      if (!data || !data.PrdID) {
        item.PrdCardName = null;
        this.farmLotsList = [];
        this.$set(item, "TasProducerContractDetail", []);
        return;
      }

      item.PrdCardName = data.PrdCardName;
      await this.fetchFarmLots(data.PrdID);
    },
    async fetchFarmLots(PrdID) {
      if (this.loadingLots) return;
      this.loadingLots = true;
      try {
        const response = await TasProducerContractService.FarmLotProducerList(
          PrdID,
          this.$fun.getUserID(),
        );
        this.farmLotsList = response.data || [];
        await this.updateAllWeeklyProjections();
      } catch (error) {
        console.error("Error al obtener lotes del productor:", error);
        this.farmLotsList = [];
      } finally {
        this.loadingLots = false;
      }
    },
    async updateAllWeeklyProjections(cmaId = null) {
      if (!this.farmLotsList || this.farmLotsList.length === 0) {
        return;
      }

      const currentCmaId =
        cmaId ||
        this.editedItem?.CmaId ||
        this.$refs.scrudProducerContract?.row?.CmaId;
      if (!currentCmaId) {
        return;
      }

      const userId = this.$fun.getUserID();

      // For each farm lot, fetch the projection data asynchronously
      const enhancedFarmLots = await Promise.all(
        this.farmLotsList.map(async (farmLot) => {
          try {
            const response =
              await _WeeklyProjectionService.TasWeeklyProjectionLoteCampaign(
                farmLot.FltID,
                currentCmaId,
                userId,
              );

            const projectionData = response.data || {};

            return {
              ...farmLot,
              typeStatePhenologicalName:
                projectionData.typeStatePhenologicalName || "---",
              StpPercentage: projectionData.StpPercentage || "---",
              DateBeginharvest: projectionData.DateBeginharvest || "---",
              DateEndharvest: projectionData.DateEndharvest || "---",
              WptProjectedJabas: projectionData.WptProjectedJabas || "---",
            };
          } catch (error) {
            console.error(
              `Error fetching weekly projection for FltID ${farmLot.FltID}:`,
              error,
            );
            return {
              ...farmLot,
              typeStatePhenologicalName: "---",
              StpPercentage: "---",
              DateBeginharvest: "---",
              DateEndharvest: "---",
              WptProjectedJabas: "---",
            };
          }
        }),
      );

      // Overwrite the FarmLots array with the newly enhanced array, ensuring PcdID is preserved
      this.farmLotsList = enhancedFarmLots;
    },
    add() {
      this.editMode = false;
      this.editedItem = {
        PctID: 0,
        PrdID: null,
        PrdCardName: null,
        CmaId: null,
        TypeProducerContract: null,
        BeginDateContract: null,
        EndDateContract: null,
        PctPrice: null,
        PctVolume: null,
        PctTermsOfPayment: null,
        TasProducerContractDetail: [],
      };
      this.farmLotsList = [];
      this.dialog = true;
    },
    async edit() {
      if (this.currentSelectedContract && this.currentSelectedContract.PctID) {
        this.editMode = true;
        this.editedItem = { ...this.currentSelectedContract };
        this.dialog = true;

        try {
          this.loadingLots = true;
          // Hacer la consulta directamente para este contrato. Esto es 100% seguro
          // y evita cualquier conflicto de tiempos (race condition) si el usuario hace doble clic muy rápido.
          const response =
            await TasProducerContractService.ProducerContractDetailList(
              this.editedItem.PctID,
              this.$fun.getUserID(),
            );

          const lots = response.data || [];
          this.farmLotsList = lots;

          // Cargar proyecciones para esta lista (usando el CmaId del contrato seleccionado)
          await this.updateAllWeeklyProjections(this.editedItem.CmaId);

          // Filtrar y marcar los checks en el formulario modal
          const savedDetails = this.farmLotsList.filter(
            (lot) => lot.PcdID && lot.PcdID > 0,
          );
          this.$set(this.editedItem, "TasProducerContractDetail", savedDetails);
          this.selectedContractDetails = savedDetails;
        } catch (error) {
          console.error("Error al cargar los detalles para la edición:", error);
        } finally {
          this.loadingLots = false;
        }
      } else {
        this.$fun.alert("Debe seleccionar un contrato para editar", "warning");
      }
    },
    async saveForm() {
      const item = this.editedItem;
      if (!item.PrdID) {
        this.$fun.alert("Debe seleccionar un Productor", "warning");
        return;
      }

      if (
        !item.TasProducerContractDetail ||
        item.TasProducerContractDetail.length === 0
      ) {
        this.$fun.alert(
          "Debe seleccionar al menos un fundo del productor",
          "warning",
        );
        return;
      }

      if (!item.BeginDateContract) {
        this.$fun.alert(
          "Debe ingresar la Fecha de Inicio de Contrato",
          "warning",
        );
        return;
      }

      if (!item.EndDateContract) {
        this.$fun.alert("Debe ingresar la Fecha de Fin de Contrato", "warning");
        return;
      }

      if (this.$moment(item.EndDateContract).isBefore(item.BeginDateContract)) {
        this.$fun.alert(
          "La Fecha de Fin no puede ser menor a la Fecha de Inicio",
          "warning",
        );
        return;
      }

      this.$fun.alert("¿Seguro de Guardar?", "question").then(async (val) => {
        if (val.value) {
          try {
            item.UsrCreateID = this.editMode
              ? item.UsrCreateID
              : this.$fun.getUserID();
            item.UsrUpdateID = this.editMode ? this.$fun.getUserID() : 0;

            const finalDetails = [];
            this.farmLotsList.forEach((lot) => {
              const isSelected = item.TasProducerContractDetail.some(
                (d) => d.FltID === lot.FltID,
              );

              if (isSelected) {
                finalDetails.push({
                  PcdID: lot.PcdID ? lot.PcdID : 0,
                  PctID: lot.PctID || item.PctID || 0,
                  FltID: lot.FltID,
                  FrcID: lot.FrcID || 0,
                  SecStatus: 1,
                });
              } else if (lot.PcdID && lot.PcdID > 0) {
                finalDetails.push({
                  PcdID: lot.PcdID,
                  PctID: lot.PctID || item.PctID || 0,
                  FltID: lot.FltID,
                  FrcID: lot.FrcID || 0,
                  SecStatus: 0,
                });
              }
            });

            item.TasProducerContractDetail = finalDetails;

            const response = await TasProducerContractService.save(
              item,
              this.$fun.getUserID(),
            );
            if (response.status === 200) {
              this.$fun.alert(
                this.editMode
                  ? "Actualizado Correctamente"
                  : "Agregado Correctamente",
                "success",
              );
              this.dialog = false;
              this.$refs.scrudProducerContract.refresh();
            }
          } catch (error) {
            console.error("Error al guardar contrato:", error);
            this.$fun.alert("Ocurrió un error al guardar el contrato", "error");
          }
        }
      });
    },
    refresh(item) {
      console.log("refresh");
      this.$emit("refresh", item);
      console.log(item);
    },
    save(item) {
      if (!item.PrdID) {
        this.$fun.alert("Debe seleccionar un Productor", "warning");
        return;
      }

      if (
        !item.TasProducerContractDetail ||
        item.TasProducerContractDetail.length === 0
      ) {
        this.$fun.alert(
          "Debe seleccionar al menos un fundo del productor",
          "warning",
        );
        return;
      }

      if (!item.BeginDateContract) {
        this.$fun.alert(
          "Debe ingresar la Fecha de Inicio de Contrato",
          "warning",
        );
        return;
      }

      if (!item.EndDateContract) {
        this.$fun.alert("Debe ingresar la Fecha de Fin de Contrato", "warning");
        return;
      }

      if (this.$moment(item.EndDateContract).isBefore(item.BeginDateContract)) {
        this.$fun.alert(
          "La Fecha de Fin no puede ser menor a la Fecha de Inicio",
          "warning",
        );
        return;
      }

      // Si pasa la validación, asignamos y guardamos
      item.UsrCreateID = this.$fun.getUserID();

      const finalDetails = [];
      this.farmLotsList.forEach((lot) => {
        // ¿Está seleccionado en la tabla?
        const isSelected = item.TasProducerContractDetail.some(
          (d) => d.FltID === lot.FltID,
        );

        if (isSelected) {
          finalDetails.push({
            PcdID: lot.PcdID ? lot.PcdID : 0,
            PctID: lot.PctID || item.PctID || 0,
            FltID: lot.FltID,
            FrcID: lot.FrcID || 0,
            SecStatus: 1,
          });
        } else if (lot.PcdID && lot.PcdID > 0) {
          // Si no está seleccionado pero tiene PcdID, significa que fue desmarcado
          finalDetails.push({
            PcdID: lot.PcdID,
            PctID: lot.PctID || item.PctID || 0,
            FltID: lot.FltID,
            FrcID: lot.FrcID || 0,
            SecStatus: 0,
          });
        }
      });

      item.TasProducerContractDetail = finalDetails;

      item.save();
    },

    async rowSelected(item) {
      this.selectedDetailsForContract = [];
      this.selectedLotForAdenda = null;
      this.adendaList = [];
      // Limpiar inmediatamente las listas para evitar estados temporales con datos antiguos
      this.farmLotsList = [];
      this.selectedContractDetails = [];

      if (item.length == 0) {
        this.currentSelectedContract = {};
        this.lastSelectedPctID = null;
      } else {
        const selectedContract = item[0];
        this.currentSelectedContract = selectedContract;
        const currentPctID = selectedContract.PctID;

        // Registrar el último ID solicitado
        this.lastSelectedPctID = currentPctID;

        if (selectedContract && currentPctID) {
          try {
            this.loadingLots = true;
            // 1. Traer todos los lotes para la tabla
            const response =
              await TasProducerContractService.ProducerContractDetailList(
                currentPctID,
                this.$fun.getUserID(),
              );

            // Validar si el usuario seleccionó otra fila mientras cargaba esta consulta
            if (this.lastSelectedPctID !== currentPctID) {
              return;
            }

            const lots = response.data || [];
            this.farmLotsList = lots;

            // 2. Cargar proyecciones para esta lista (usando el CmaId del contrato seleccionado)
            await this.updateAllWeeklyProjections(selectedContract.CmaId);

            // Segunda validación después de cargar las proyecciones (que también es asíncrona)
            if (this.lastSelectedPctID !== currentPctID) {
              return;
            }

            // 3. Extraer los que están marcados (ya con proyecciones cargadas)
            const savedDetails = this.farmLotsList.filter(
              (lot) => lot.PcdID && lot.PcdID > 0,
            );

            this.$set(
              selectedContract,
              "TasProducerContractDetail",
              savedDetails,
            );

            // Almacenar para la tabla de visualización inferior
            this.selectedContractDetails = savedDetails;
          } catch (error) {
            console.error("Error al cargar los detalles del contrato:", error);
          } finally {
            if (this.lastSelectedPctID === currentPctID) {
              this.loadingLots = false;
            }
          }
        }
      }
    },
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format(
        this.$const.FormatDateView || "DD/MM/YYYY",
      );
    },
    getStatusColor(status) {
      if (status == 1) return "success"; // Verde
      if (status == 2) return "error"; // Rojo
      if (status == 3) return "warning"; // Amarillo
      return "grey";
    },
    openAddendaModal(item) {
      this.selectedPcdID = item.PcdID;
      this.selectedFltID = item.FltID;
      this.dialogAddenda = true;
    },
    async onLotRowClicked(row) {
      this.selectedLotForAdenda = row;
      this.loadingAdendas = true;
      try {
        const response = await TasProducerContractService.AddendaList(
          row.PcdID,
          this.$fun.getUserID(),
        );
        this.adendaList = response.data || [];
      } catch (error) {
        console.error("Error al cargar las adendas:", error);
        this.adendaList = [];
      } finally {
        this.loadingAdendas = false;
      }
    },
    onDownloadAdendaPDF(item) {
      this.selectedAdendaForPdf = item;
      this.showAdendaPdfDialog = true;
    },
    rowClass(item) {
      if (
        this.selectedLotForAdenda &&
        this.selectedLotForAdenda.FltID === item.FltID
      ) {
        return "selected-row-active";
      }
      return "";
    },
    isSelectable(item) {
      return !(item.CountAddenda && item.CountAddenda > 0);
    },
    onItemSelected({ item, value }) {
      if (value === false && item.CountAddenda && item.CountAddenda > 0) {
        this.$fun.alert(
          "No se puede desasociar este fundo porque tiene adendas registradas.",
          "warning",
        );
        // Volver a agregarlo a la lista de seleccionados si se quitó
        if (
          !this.editedItem.TasProducerContractDetail.some(
            (x) => x.FltID === item.FltID,
          )
        ) {
          this.editedItem.TasProducerContractDetail.push(item);
        }
      }
    },
    onToggleSelectAll({ items, value }) {
      if (value === false) {
        // Encontrar todos los fundos deseleccionados que tienen adendas
        const nonDeselectable = items.filter(
          (item) => item.CountAddenda && item.CountAddenda > 0,
        );
        if (nonDeselectable.length > 0) {
          this.$fun.alert(
            "Algunos fundos no se desasociaron porque tienen adendas registradas.",
            "warning",
          );
          // Volver a agregarlos todos
          nonDeselectable.forEach((item) => {
            if (
              !this.editedItem.TasProducerContractDetail.some(
                (x) => x.FltID === item.FltID,
              )
            ) {
              this.editedItem.TasProducerContractDetail.push(item);
            }
          });
        }
      }
    },
    async refreshContractDetails() {
      if (this.editedItem && this.editedItem.PctID) {
        try {
          const response =
            await TasProducerContractService.ProducerContractDetailList(
              this.editedItem.PctID,
              this.$fun.getUserID(),
            );

          const lots = response.data || [];
          this.farmLotsList = lots;

          // Filtrar y marcar los checks en el formulario modal
          const savedDetails = this.farmLotsList.filter(
            (lot) => lot.PcdID && lot.PcdID > 0,
          );
          this.$set(this.editedItem, "TasProducerContractDetail", savedDetails);
          this.selectedContractDetails = savedDetails;
        } catch (error) {
          console.error("Error al refrescar los detalles del contrato:", error);
        }
      }
    },
  },
};
</script>
<style scoped>
/* Asegurar que las celdas y cabeceras de la tabla no colapsen y causen superposición, especialmente cuando hay muchas columnas */
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: nowrap;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  white-space: nowrap;
}

/* Fila seleccionada en color celeste/azul suave y su efecto hover */
::v-deep .selected-row-active {
  background-color: #e3f2fd !important;
}

::v-deep .selected-row-active:hover {
  background-color: #bbdefb !important;
}
</style>
